import React, {useState} from 'react'
import {Button} from "antd";
import {getBrandsAsSelect} from "../../services/serviceBrand";
import EmployeeBrandMatch from "./EmployeeBrandMatch";

const EmployeeBrand = ({employeeId}) => {
    const [brands, setBrands] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const handleMatchClick = () => {
        getBrandsAsSelect()
            .then(({data}) => {
                if(data) {
                    setBrands(data.map(i => ({label: i.label, value: i.key, key: i.key})));
                    setShowModal(!showModal);
                }
            })
    };

    const closeModal = () => {
        setShowModal(!showModal);
    };

    return(
        <React.Fragment>
            <Button
                type={'link'}
                onClick={handleMatchClick}
            >
                Marka Eşleştir
            </Button>

            {
                showModal ?
                    <EmployeeBrandMatch
                        show={showModal}
                        employeeId={employeeId}
                        brandList={brands}
                        modalCloser={closeModal}
                    />
                    : null
            }

        </React.Fragment>
    )
}
export default EmployeeBrand